import React, { Component } from "react";
import Search from "../../../../common/components/search-text/search-text";
import Button from "../../../button-classic/button-classic";
import { connect } from "react-redux";
import ACTIONS from "../../../../common/action_constant";
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import { withRouter } from "react-router-dom";
import AddMannedWeighBridgeMaster from "./add-manned-weighbridge-master";
import { getItemFromSessionStorage } from "Utils/sessionStorage";
import { getEmail, getUserId } from "Utils/common";

class MannedWeighBridgeMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      offset: 0,
      limit: 10,
      mannedWeighBridgeData: [],
      count: 10,
    };
  }
  componentDidMount() {
    this.getMannedWeighBridgeMaster();
  }

  getMannedWeighBridgeMaster() {
    const { dispatch, companyId , branchId} = this.props;
    const { search, offset, limit } = this.state;
    let param = `?companyId=${companyId}&branchId=${branchId}&limit=${limit}&offset=${offset}`;
    if (search) {
      param += `&search=${search}`;
    }
    dispatch({
      type: ACTIONS.PLANTS.GET_MANNED_WEIGHBRIDGE_MASTER,
      param,
      onSuccess: (res) => {
        this.setState({ mannedWeighBridgeData: res && res });
      },
    });
  }


  changeHandler = (value) => {
    this.setState({ search: value });
  };

  toggleAdd = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen, editData: "" });
  };

  onSaveMannedWeighBridgeMaster = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.ADD_MANNED_WEIGHBRIDGE_MASTER,
      data,

      onSuccess: () => {
        this.setState({ isOpen: false }, this.getMannedWeighBridgeMaster());
      },
    });
  };

  onSearch = () => {
    this.setState({ offset: 0 }, this.getMannedWeighBridgeMaster);
  };

  onUpdateMannedWeighBridgeMaster = (data) => {
    const previousData = getItemFromSessionStorage("previousMannedWeighBridgeData");
    const { dispatch } = this.props;
    const payload = {
      ...data,
      previous_data: previousData,
    };
    dispatch({
      type: ACTIONS.PLANTS.UPDATE_MANNED_WEIGHBRIDGE_MASTER,
      data: payload,
      onSuccess: () => {
        this.setState({ isOpen: false, editData: "" }, this.getMannedWeighBridgeMaster);
      },
    });
  };

  editSapMaster = (data) => {
    this.setState({
      editData: data,
      isOpen: true,
    });
  };

  deleteSapMaster = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.DELETE_MANNED_WEIGHBRIDGE_MASTER,
      data: data,
      onSuccess: () => {
        this.getMannedWeighBridgeMaster();
      },
    });
  };

  previous = () => {
    if (this.state.offset >= this.state.limit) {
      this.setState(
        (prevState) => ({
          offset: prevState.offset - prevState.limit,
        }),
        this.getMannedWeighBridgeMaster
      );
    }
  };

  next = () => {
    this.setState(
      (prevState) => ({
        offset: prevState.offset + prevState.limit,
      }),
      this.getMannedWeighBridgeMaster
    );
  };

  clearFilterOnCancel = () => {
    this.setState({ search: "", offset: 0 }, this.getMannedWeighBridgeMaster);
  };

  handleOnClickForAuditBtn = () => {
    const { history, companyId ,branchId} = this.props;
    const masterType = 61;
    const navUrl = `/auditScreen/${companyId}/${masterType}/${branchId}`;
    history.push(navUrl);
  };

  render() {
    const { mannedWeighBridgeData } = this.state;
    return (
      <div className={"location-network"}>
        <div>
          <div style={{ display: "block", paddingBottom: "15px" }}>
            <Search
              id="search"
              value={this.state.search}
              placeholder="Search..."
              changeHandler={this.changeHandler}
              click={this.onSearch}
              canClear={this.state.search !== ""}
              handleClearFilter={this.clearFilterOnCancel}
            />
            <Button value={"+ Add WeighBridge Master"} click={this.toggleAdd} />
            <button
              className="button-classic"
              onClick={this.handleOnClickForAuditBtn}
            >
              Audit WeighBridge Master
            </button>
          </div>
        </div>
        <table className="custom-sap-table">
          <thead>
            <tr>
              <th>Plant Name</th>
              <th>Plant Code</th>
              <th>Vendor</th>
              <th>WeighBridge Port</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {(mannedWeighBridgeData || []).map((weigh, sIndex) => (
              <tr key={`route_${sIndex}`}>
                <td>{weigh.plant_name}</td>
                <td>{weigh.plant_code}</td>
                <td>{weigh.vendor}</td>
                <td>{weigh.weigh_bridge_port}</td>
                <td>
                  <div
                    className="action-icon"
                    style={{ backgroundImage: `url(${Edit})` }}
                    onClick={() => this.editSapMaster(weigh)}
                  />
                  <div
                    className="action-icon"
                    style={{ backgroundImage: `url(${Delete})` }}
                    onClick={() => this.deleteSapMaster(weigh)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={this.next} />
          </div>
          <div className="pre">
            <Button value="Previous" click={this.previous} />
          </div>
        </div>
        {this.state.isOpen && (
          <AddMannedWeighBridgeMaster
            toggleAdd={this.toggleAdd}
            onSave={this.onSaveMannedWeighBridgeMaster}
            companyId={this.props.companyId}
            branchId={this.props.branchId}
            editData={this.state.editData}
            onUpdate={this.onUpdateMannedWeighBridgeMaster}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zones: state.plantsDepots.zones,
    countryListData: state.master.countryList,
    productList: state.master.itemList,
    routeCodeList: state.home.routeCodes || [],
  };
};

export default connect(mapStateToProps)(withRouter(MannedWeighBridgeMaster));
